<template>
  <el-submenu index="4" class="menu-item-products" popper-class="menu-item-products-options" :popper-append-to-body="true">
    <template slot="title"><svgicon name="multiproducts" class="multiProductsIcon"></svgicon></template>
    <el-menu-item
      v-for="(product, key) in products"
      :index="'4-' + key"
      @click="() => handleClick(product)"
      :key="key" :class="{ 'active': product === origin }">
      <svgicon :name="key"></svgicon>{{ $t(key) }}
    </el-menu-item>
  </el-submenu>
</template>

<script>

export default {
  name: 'iDalgo-Multi-Products',
  computed: {},
  data () {
    return {
      products: process.env.PRODUCTS,
      origin: window.location.origin
    }
  },
  methods: {
    handleClick (product) {
      window.location.href = product
    }
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/iDalgo-Nav-Menus/iDalgo-Multi-Products.vue